import { createAuthRetryInterceptor as createSharedAuthRetryInterceptor } from '@zealot/ui';
import logger from '@/utils/logger';
import { removeAccessToken } from './tokenStorage';
import type { FetchTokenFn } from './types';

// gloss
export const createAuthRetryInterceptor = (fetchTokenRef: { current: FetchTokenFn }) =>
  createSharedAuthRetryInterceptor(fetchTokenRef, {
    onBeforeRefresh: removeAccessToken,
    onError: (error, url) => logger.error(error, { context: 'authRetryInterceptor', url }),
  });
